import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const Footer = () => {
  const footerRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ Anchor handler (same as Header)
  const handleAnchorClick = (e, section) => {
    if (location.pathname !== "/") {
      e.preventDefault();
      navigate("/");

      setTimeout(() => {
        document.getElementById(section)?.scrollIntoView({
          behavior: "smooth",
        });
      }, 150);
    }
  };

  // ✅ Animation observer (unchanged)
  useEffect(() => {
    let footerObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-animating");

            setTimeout(() => {
              entry.target.classList.add("show-details");
            }, 1000);

            footerObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (footerRef.current) {
      footerObserver.observe(footerRef.current);
    }

    return () => {
      if (footerRef.current) footerObserver.unobserve(footerRef.current);
    };
  }, []);

  return (
    <footer className="app-footer custom-footer" ref={footerRef}>
      <div className="container footer-details">
        <div className="row w-100 justify-content-between text-start">

          {/* QUICK LINKS */}
          <div className="col-md-3 footer-col">
            <h5 className="footer-heading">Quick Links</h5>
            <ul className="footer-list">

              <li>
                <a
                  href="#home"
                  onClick={(e) => handleAnchorClick(e, "home")}
                  className="nav-link"
                >
                  Home
                </a>
              </li>

              <li>
                <a
                  href="#features"
                  onClick={(e) => handleAnchorClick(e, "features")}
                  className="nav-link"
                >
                  Key Features
                </a>
              </li>

              <li>
                <a
                  href="#how-it-works"
                  onClick={(e) => handleAnchorClick(e, "how-it-works")}
                  className="nav-link"
                >
                  How It Works
                </a>
              </li>

              <li>
                <a
                  href="#reviews"
                  onClick={(e) => handleAnchorClick(e, "reviews")}
                  className="nav-link"
                >
                  Reviews
                </a>
              </li>

            </ul>
          </div>

          {/* CONTACT */}
          <div className="col-md-4 footer-col">
            <h5 className="footer-heading">Contact</h5>
            <ul className="footer-list">
              <li>
                <a href="tel:2623706232">262-370-6232</a>
              </li>
              <li>
                <a href="mailto:support@remoteref.com">
                  support@remoteref.com
                </a>
              </li>
              <li>N160W19589 Clover Ln.  Jackson WI, 53037</li>
            </ul>
          </div>

          {/* SOCIAL */}
          <div className="col-md-3 footer-col">
            <h5 className="footer-heading socail-heading">Social Media</h5>
            <div className="footer-socials">
              <a href="#"><i className="fa-brands fa-facebook-f"></i></a>
              <a href="#"><i className="fa-brands fa-instagram"></i></a>
              <a href="#"><i className="fa-brands fa-x-twitter"></i></a>
              <a href="#"><i className="fa-brands fa-linkedin-in"></i></a>
            </div>
          </div>

        </div>
      </div>

      {/* MASSIVE TEXT */}
      <div className="footer-massive-text" id="text">
        <span>R</span><span>e</span><span>m</span>
        <span className="custom-o-ball">
          <img src="/images/ball.png" alt="" />
        </span>
        <span>t</span><span>e</span><span>&nbsp;</span>
        <span>R</span><span>e</span><span>f</span>
      </div>
    </footer>
  );
};

export default Footer;